import { createContext } from 'react';

/** Una página visitada: la URL completa (con filtros) y cómo se llamaba. */
export interface PaginaVisitada {
    href: string;
    titulo: string;
    /** Bloque y sección del menú, para distinguir pantallas con el mismo nombre. */
    detalle?: string;
}

export interface PaginaReciente extends PaginaVisitada {
    fecha: number;
}

export interface NavegacionContextValue {
    /** Página anterior dentro del ERP en esta pestaña; undefined si se entró directo. */
    anterior?: PaginaVisitada;
    recientes: PaginaReciente[];
    /** La ruta del sub-header informa cómo se llama la página actual. */
    registrarTitulo: (href: string, titulo: string, detalle?: string) => void;
    borrarRecientes: () => void;
}

const NavegacionContext = createContext<NavegacionContextValue>({
    recientes: [],
    registrarTitulo: () => {},
    borrarRecientes: () => {},
});

export default NavegacionContext;
